import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from "react";
import { toast } from "react-toastify";
import { Box, Fade } from "@mui/material";
import { useBulkOrderCancelActiveShipmentMutation } from "store/services/vendorProfileApi";
import { BulkCancelForm } from "./BulkCancelForm";

export const BulkCancelScreen = () => {
  const [isProcessing, setIsProcessing] = React.useState(false);

  const breadcrumbs = [
    {
      title: "Shipment List",
      path: "/app/crm/shipment/list",
    },
    {
      title: "Bulk Cancel",
    },
  ];

  const [cancelBulkShipment, { isLoading: cancellingShipment }] =
    useBulkOrderCancelActiveShipmentMutation();

const handleBulkShipmentCancel = async (submitData) => {
  setIsProcessing(true);

  try {
    const result = await cancelBulkShipment(submitData).unwrap();
    if (result.success) {
      if (result.data?.failed && result.data.failed > 0) {
        toast.warning(
          `${result.data.processed} shipments cancelled successfully, ${result.data.failed} failed`,
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
        if (result.data.errors && result.data.errors.length > 0) {
          console.log("Failed shipments:", result.data.errors);
        }
      } else {
        const processedCount =
          result.data?.processed || submitData.shipments.length;
        toast.success(`Successfully cancelled ${processedCount} shipment(s)`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } else {
      toast.error(result.message || "Failed to cancel shipments");
    }
  } catch (err) {
    console.error("Bulk cancel error:", err);
  } finally {
    setIsProcessing(false);
  }
};

  const isBusy = cancellingShipment || isProcessing;

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isBusy}>
      <BreadcrumbLayout.Paper>
        <Fade in timeout={800}>
          <Box p={3}>
            <BulkCancelForm
              isBusy={isBusy}
              onSubmit={handleBulkShipmentCancel}
            />
          </Box>
        </Fade>
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};